const INAPP_UPI_AWARENESS_HALFCARD_PREFIX = "inapp_upi_awareness_halfcard";
export const INAPP_UPI_AWARENESS_HALFCARD_TEST_IDS = {
    CONTAINER: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_container`,
    TITLE: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_title`,
    DESCRIPTION: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_description`,
    IMAGE: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_image`,
    CTA: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_cta`,
    SUBTEXT: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_subtext`,
    SUBTITLE: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_subtitle`,
    LOTTIE: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_lottie`,
    POWERED_BY_IMAGE: `${INAPP_UPI_AWARENESS_HALFCARD_PREFIX}_powered_by_image`,
};
